const { default: accordionBtns } = require("./accordionButtons");
const { default: equalHeights } = require("./equalHeights");
const { default: mobNav } = require("./mobNav");

document.addEventListener('DOMContentLoaded', event => {
    /* CSS TRANSITION ON PAGE LOAD FIX */
    document.body.classList.remove("css-transitions-only-after-page-load");

    mobNav();
    accordionBtns();
});

equalHeights();